import { render } from "./Login.vue?vue&type=template&id=85954c66&bindings={\"input\":\"data\",\"isLector\":\"options\",\"olvide\":\"options\",\"login\":\"options\"}"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"
script.render = render

export default script